module.exports = __webpack_public_path__ + "static/media/david_schottlander.c6a1a027.png";